class Preloader {
  constructor() {
    this.loaders = [];
    this.namedLoaders = new Map();
  }

  init(props = {}) {
    this.completeHandle = props.onComplete || null;
    this.progressHandle = props.onProgress || null;
  }

  load(fileList = []) {
    const saveFile = (id, file) => {
      this.namedLoaders.set(id, file);
    };

    const loadImage = (url) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('error', () => fulfill(false));
        img.addEventListener('load', () => fulfill(img));
        const fulfill = (imgResult) => {
          imgResult ? resolve(img) : reject(`File not found: ${url}`);
        };
        img.src = url;
      });

    const onProgress = () => {
      this.filesLeft--;
      const progress = 1 - this.filesLeft / this.loaders.length;
      if (progress < 1 && this.progressHandle) {
        this.progressHandle(progress);
      }
    };

    return new Promise((resolve, reject) => {
      this.filesLeft = fileList.length;
      fileList.forEach((file) => {
        if (typeof file === 'string') {
          this.loaders.push(
              loadImage(file).then((img) => {
                onProgress();
                return img;
              })
          );
          return;
        } else if (file.type === 'image') {
          this.loaders.push(
              loadImage(file.url).then((img) => {
                onProgress();
                if (file.id) {
                  saveFile(file.id, img);
                }
                return img;
              })
          );
          return;
        } else if (file.type === 'json') {
          this.loaders.push(
              fetch(file.url)
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error(`File not found: ${file.url}`);
                    }
                    return response.json();
                  })
                  .then((data) => {
                    onProgress();
                    if (file.id) {
                      saveFile(file.id, data);
                    }
                    return data;
                  })
          );
        } else {
          this.loaders.push(
              fetch(file.url)
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error(`File not found: ${file.url}`);
                    }
                    return response.text();
                  })
                  .then((data) => {
                    onProgress();
                    if (file.id) {
                      saveFile(file.id, data);
                    }
                    return data;
                  })
          );
        }
      });

      Promise.all(this.loaders)
          .then(() => {
            resolve();
          })
          .catch((e) => console.log(e));
    });
  }

  getFile(id) {
    return this.namedLoaders.get(id);
  }

  updateFile(id, value) {
    return this.namedLoaders.set(id, value);
  }
}

export default new Preloader();
